import { render } from "./MyCheck2.vue?vue&type=template&id=2a9a9474&scoped=true"
import script from "./MyCheck2.vue?vue&type=script&lang=js"
export * from "./MyCheck2.vue?vue&type=script&lang=js"

import "./MyCheck2.vue?vue&type=style&index=0&id=2a9a9474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9a9474"]])

export default __exports__